<template>
  <div>
    <div class="d-flex align-center mb-1">
      <v-select
        v-model="selectedName"
        :items="messageNames"
        label="Saved Messages"
        dense
        hide-details
        clearable
        class="input-text-size"
        style="max-width: 240px"
        @change="loadMessage"
      />
      <v-btn small outlined color="primary" class="ml-2" @click="openSaveDialog">Save</v-btn>
      <v-btn
        v-if="selectedName"
        small
        outlined
        color="error"
        class="ml-2"
        @click="pendingDeleteName = selectedName; deleteDialog = true"
      >Delete</v-btn>
    </div>

    <TextEditorField :placeholder="placeholder" v-model="internalValue" :classes="classes" />

    <v-dialog v-model="saveDialog" max-width="400">
      <v-card>
        <v-card-title class="text-subtitle-1">Save Message As</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="saveName"
            label="Name"
            dense
            autofocus
            @keydown.enter="confirmSave"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text small @click="saveDialog = false">Cancel</v-btn>
          <v-btn color="primary" small :disabled="!saveName.trim()" @click="confirmSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="420" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1">Delete Saved Message</v-card-title>
        <v-card-text>
          Are you sure you want to delete
          <strong>{{ pendingDeleteName }}</strong>?
          This cannot be undone.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text small @click="cancelDelete">Cancel</v-btn>
          <v-btn color="error" small @click="executeDelete">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TextEditorField from './TextEditorField.vue';

export default {
  name: 'MiddleMessageSaveList',
  components: { TextEditorField },

  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    classes: { type: String, default: '' },
    savedMessages: { type: Array, default: () => [] },
  },

  data() {
    return {
      selectedName: null,
      saveDialog: false,
      saveName: '',
      deleteDialog: false,
      pendingDeleteName: null,
    };
  },

  computed: {
    internalValue: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); },
    },
    messageNames() {
      return (this.savedMessages || []).map((m) => m.name);
    },
  },

  watch: {
    messageNames(newNames) {
      if (this.selectedName && !newNames.includes(this.selectedName)) {
        this.selectedName = null;
      }
    },
  },

  methods: {
    loadMessage(name) {
      if (!name) return;
      const found = (this.savedMessages || []).find((m) => m.name === name);
      if (found) {
        this.internalValue = found.content;
      }
    },

    openSaveDialog() {
      this.saveName = this.selectedName || '';
      this.saveDialog = true;
    },

    confirmSave() {
      const name = this.saveName.trim();
      if (!name) return;
      this.$emit('save-message', { name, content: this.value });
      this.selectedName = name;
      this.saveDialog = false;
      this.saveName = '';
    },

    cancelDelete() {
      this.deleteDialog = false;
      this.pendingDeleteName = null;
    },

    executeDelete() {
      const name = this.pendingDeleteName || this.selectedName;
      this.deleteDialog = false;
      this.pendingDeleteName = null;
      this.selectedName = null;
      this.internalValue = '';
      this.$emit('delete-message', name);
    },
  },
};
</script>
